import {connect} from 'react-redux';
import SEOIntroductionParagraphComponent from './SEOIntroductionParagraph.js';

export function mapStateToProps(state) {
    return {
        labels: state.modules.seoIntroduction.labels,
        introduction: state.modules.seoIntroduction.introduction,
    };
}
export const SEOIntroductionParagraph = connect(mapStateToProps)(
    SEOIntroductionParagraphComponent
);

SEOIntroductionParagraph.displayName = 'SEOIntroductionParagraph';

export default SEOIntroductionParagraph;
